import { SearchParams } from 'elasticsearch'
const ELASTIC_URL = '/elastic/materials/_search'

let controller: AbortController
let abortTimer: number
export const searchMaterials = async (payload: SearchParams) => {
  if (controller && abortTimer) {
    clearTimeout(abortTimer)
    controller.abort()
  }

  // @ts-ignore
  controller = new window.AbortController()
  const { signal } = controller
  const _abortTimer = window.setTimeout(() => {
    controller.abort()
    throw new Error('Request timed out')
  }, 30000)
  abortTimer = _abortTimer

  const res = await window.fetch(ELASTIC_URL, {
    signal,
    credentials: 'same-origin',
    redirect: 'manual',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(payload)
  })

  clearTimeout(abortTimer)

  if (res.status === 200) {
    return res.json()
  } else {
    throw new Error('Something went wrong')
  }
}
